import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js';
function GeneralLedger() {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [ledgerData, setLedgerData] = useState([]);
    const [account, setAccount] = useState('');
    const fetchLedger = () => {
        const start = startDate ? startDate.toISOString().substring(0, 10) : '';
        const end = endDate ? endDate.toISOString().substring(0, 10) : '';
        axios.get(`${baseUrl}general-ledger/?start=${start}&end=${end}&account=${account}`)
            .then(res => {
                setLedgerData(res.data);
            })
            .catch(err => console.log(err));
    };
    useEffect(() => {
        fetchLedger();
    }, [startDate, endDate, account]);
    const columns = [
        {field: 'date', headerName: 'Date', width: 120},
        {field: 'ref_no', headerName: 'Ref No', width: 120},
        {field: 'module', headerName: 'Module', width: 150},
        {field: 'account', headerName: 'Account Head', width: 250},
        {field: 'debit', headerName: 'Debit', width: 120},
        {field: 'credit', headerName: 'Credit', width: 120},
    ];
    return (
        <section className="container mt-4">

            <h3 className="text-center bg-primary text-white p-2">
                General Ledger
            </h3>

            <div className="row mb-3">

                <div className="col-md-3">
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="From Date"
                        className="form-control"
                    />
                </div>

                <div className="col-md-3">
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholderText="To Date"
                        className="form-control"
                    />
                </div>

                <div className="col-md-3">
                    <select
                        className="form-control"
                        value={account}
                        onChange={(e) => setAccount(e.target.value)}
                    >
                        <option value="">All Accounts</option>
                        <option value="Cash">Cash</option>
                        <option value="Bank">Bank</option>
                        <option value="Accounts Payable">Accounts Payable</option>
                        <option value="Pharmacy Revenue">Pharmacy Revenue</option>
                        <option value="OP Revenue">OP Revenue</option>
                        <option value="Lab Revenue">Lab Revenue</option>
                    </select>
                </div>

            </div>
            <div style={{height: "100%", width: "100%"}}>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}

                          rows={ledgerData}
                          columns={columns}
                          pageSize={10}
                          autoHeight
                          slots={{
                              toolbar: GridToolbar,
                          }}
                />
            </div>
        </section>
    )
}
export default GeneralLedger;